import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';
import { CapsuleCollapseLists } from 'Components/frameworks/capsule-collapse-lists/CapsuleCollapseLists';
import { Title } from 'Components/frameworks/title/Title';
import type { IconName } from 'Components/frameworks/icon/Icon';
import 'Components/frameworks/icon/Icon';
import type { ProductFeatureDetailServiceProps } from './ProductFeatureDetailService';
import { ProductFeatureDetailService } from './ProductFeatureDetailService';
type Props = {
  className?: string;
  color?: Colors;
  equipments?:
    | Array<{
        items:
          | Array<{
              iconName?: IconName;
              label: string;
            }>
          | null
          | undefined;
        title: string;
      }>
    | null
    | undefined;
  equipmentsTitle?: string;
  items: Array<ProductFeatureDetailServiceProps>;
  title?: string;
  titleIcon?: IconName;
};
export const ProductFeatureDetailServices = (props: Props) => {
  const {
    className,
    color = COLORS.BLACK,
    equipmentsTitle = '',
    equipments = [],
    items = [],
    title = '',
    titleIcon,
  } = props;

  if (!items.length) {
    return null;
  }

  const hasEquipements = !!equipments?.length;
  return (
    <section className={className}>
      <Title className="mb-20 sm:mb-15" hLevel={3} iconName={titleIcon} theme="title-brand-n2">
        {title}
      </Title>
      <div
        className={classnames({
          '-m-10 sm:flex': hasEquipements,
        })}
      >
        <div className={hasEquipements ? 'sm:w-1/2' : '-m-10 flex-wrap sm:flex'}>
          {items.map((item) => {
            return (
              !!item?.title && (
                <div
                  className={classnames('p-10', {
                    'sm:w-1/2': !hasEquipements,
                  })}
                  key={item.id}
                >
                  <ProductFeatureDetailService
                    badges={item.badges}
                    color={color}
                    duration={item.duration}
                    id={item.id}
                    items={item.items}
                    level={item.level}
                    note={item.note}
                    targetPrice={item.targetPrice}
                    title={item.title}
                  />
                </div>
              )
            );
          })}
        </div>
        {hasEquipements && (
          <div className="p-10 sm:w-1/2">
            <CapsuleCollapseLists
              header={{
                iconName: ICONS.ALL_INCLUSIVE,
                title: equipmentsTitle,
              }}
              lists={equipments}
              style={{
                maxWidth: 380,
              }}
            />
          </div>
        )}
      </div>
    </section>
  );
};
